<div class="email-content" [formGroup]="form">

  <div class="email-content_top">
    <div class="form-group switch">
      <label for="emailContentTypeSwitch" class="form-label switch-label">Text</label>
      <p-inputSwitch id="emailContentTypeSwitch" [(ngModel)]="isHtmlType" [ngModelOptions]="{standalone: true}"></p-inputSwitch>
      <label for="emailContentTypeSwitch" class="form-label switch-label">HTML Code</label>
    </div>
  </div>


  <ng-container *ngIf="!isHtmlType; else htmlContent">
    <p-editor [formControlName]="controlName" [style]="{'height':'268px'}"></p-editor>
  </ng-container>
  
  <ng-template #htmlContent>
    <app-html-content [form]="form" [controlName]="controlName"></app-html-content>
  </ng-template>

</div>
